import { render, staticRenderFns } from "./SimpleConfirmModal.vue?vue&type=template&id=0104a8dc&"
import script from "./SimpleConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./SimpleConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports